import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'aa-circle',
    templateUrl: './circle.component.html',
    styleUrls: ['./circle.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CircleComponent implements OnInit
{
    @Input() cx: number;
    @Input() cy: number;
    @Input() begin: string;

    constructor() { }

    ngOnInit ()
    {
    }

}
